const FloatingCallButton = ({thread}) => {
	if (thread.is_promote && thread.discussion_open && !thread.ft_temp_off) {
		return (
			<div className="fixed -left-5 bottom-32 quick-alo-phone quick-alo-green quick-alo-show z-50 md:bottom-5 md:left-5" id="quick-alo-phoneIcon">
				<a href={`tel:${thread.ft_phone}`} title="Liên hệ nhanh">
					<div className="quick-alo-ph-circle"></div>
					<div className="quick-alo-ph-circle-fill"></div>
					<div className="quick-alo-ph-img-circle"></div>
				</a>
			</div>
		);
	}
}

export default FloatingCallButton;